import {observer} from "mobx-react"
import {PageContentTitle} from "../../ui"
import {cmsDetailStore, growlStore} from "../../../store"
import {CmsForm, CmsFormData} from "./CmsForm";
import {CmsHistory} from "./CmsHistory";

const CmsCustomerDetail = observer(function CmsCustomerDetail() {

    const {
        name,
        customerNumber,
        addressPostCode,
        addressHouseNumber,
        addressCountry,
        addressAddition,
        addressStreet,
        addressCity,
        active,
        displayName
    } = cmsDetailStore

    const data: CmsFormData = {
        name,
        active,
        displayName,
        customerNumber,
        addressPostCode,
        addressHouseNumber,
        addressAddition,
        addressCity,
        addressCountry,
        addressStreet
    }
    const display = `${name} (${customerNumber})`
    const dirty = cmsDetailStore.dirty
    const valid = cmsDetailStore.valid

    return <>
            <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${cmsDetailStore.saving ? 'is-loading' : ''}`,
                    disabled: !(dirty && valid),
                    action: async () => {
                        await cmsDetailStore.save()
                        cmsDetailStore.reset()
                        growlStore.add({
                            message: 'Der Kunde wurde erfolgreich gespeichert',
                            autoclose: true,
                            closable: true
                        })
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: cmsDetailStore.saving || !cmsDetailStore.dirty,
                    action: async () => {
                        cmsDetailStore.reset()
                        await cmsDetailStore.load()
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <CmsForm
            mode={'update'}
            saving={cmsDetailStore.saving}
            data={data}
            validate={async () => {
                await cmsDetailStore.validate()
            }}
            onChange={val => {
                const {
                    name,
                    active,
                    displayName,
                    customerNumber,
                    addressPostCode,
                    addressHouseNumber,
                    addressAddition,
                    addressCity,
                    addressCountry,
                    addressStreet
                } = val
                cmsDetailStore.name = name
                cmsDetailStore.active = active
                cmsDetailStore.displayName = displayName
                cmsDetailStore.customerNumber = customerNumber
                cmsDetailStore.addressPostCode = addressPostCode
                cmsDetailStore.addressHouseNumber = addressHouseNumber
                cmsDetailStore.addressAddition = addressAddition
                cmsDetailStore.addressCity = addressCity
                cmsDetailStore.addressCountry = addressCountry
                cmsDetailStore.addressStreet = addressStreet
            }}/>

        <div style={{
            display: 'flex',
            borderTop: '1px solid var(--core-primary-border-color)',
        }}>
            <CmsHistory />
        </div>
    </>
})

export {
    CmsCustomerDetail
}
